import type { LegQuoteSide } from "./optionLeg.types";

/** Buy for asks, sell for bids — the default intent before the user flips it. */
export const sideForQuoteSide = (quoteSide: LegQuoteSide): "buy" | "sell" =>
  quoteSide === "ask" ? "buy" : "sell";
